import ApiService from "../api";

export default class ContaFinanceiraService extends ApiService {

    constructor() {
        super("/api/conta-financeira");
    }

    listar() {
        return this.get("");
    }

    /** Só as contas ativas — usado na escolha da conta (rateio do Lançamento de Despesa "Contas a Pagar"). */
    listarAtivas() {
        return this.get("?ativas=true");
    }

    salvar(dto) {
        return this.post("", dto);
    }

    atualizar(id, dto) {
        return this.put(`/${id}`, dto);
    }

    excluir(id) {
        return this.delete(`/${id}`);
    }

    /** Cadastra/atualiza todas as contas financeiras do FortesAG. Não apaga nada. */
    sincronizarComFortes() {
        return this.post("/sincronizar-fortes", {});
    }

    /** `formData` com o campo "file" (planilha Excel). */
    importar(formData) {
        return this.post("/importar", formData);
    }
}
